import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"

import { EmbedComponent } from "./embed.component"

const embedRoutes: Routes = [{ path: "", component: EmbedComponent }]

@NgModule({
    imports: [RouterModule.forChild(embedRoutes)],
    exports: [RouterModule],
})
export class EmbedRoutingModule {}
